import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Sheet, SheetContent } from '../ui/sheet';
import { USER_ROUTES, ADMIN_ROUTES } from '../../constants/routeConstants';

interface MobileDrawerProps {
  isOpen: boolean;
  onToggle: () => void;
  logo: string;
  isAdmin?: boolean;
  children: ReactNode;
}

const MobileDrawer = ({
  isOpen,
  onToggle,
  logo,
  isAdmin = false,
  children,
}: MobileDrawerProps) => {
  return (
    <Sheet open={isOpen} onOpenChange={(open: boolean) => !open && onToggle()}>
      <SheetContent
        side="left"
        className="w-80 p-0 sm:max-w-none"
        showClose={false}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center p-4 border-b border-gray-200">
            <Link
              to={
                isAdmin
                  ? ADMIN_ROUTES.ADMIN_DASHBOARD
                  : USER_ROUTES.USER_DASHBOARD
              }
              onClick={onToggle}
            >
              <img
                src={logo}
                alt="Logo"
                className="h-8 w-auto cursor-pointer"
              />
            </Link>
          </div>
          <div className="flex-1 overflow-y-auto">{children}</div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileDrawer;
